var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManropeV13Latin600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Manrope",
    horizAdvX: 1131
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Manrope ExtraLight SemiBold",
    unitsPerEm: 2000,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 2132,
    descent: -600,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 400
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 689,
    d: "M240 0V203H449V0H240ZM240 360V1440H449V360H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 884,
    d: "M120 1080V1440H329V1080H120ZM475 1080V1440H684V1080H475Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 1855,
    d: "M389 1L497 406H120L173 605H551L620 868H243L297 1065H673L774 1440H979L878 1065H1153L1254 1440H1459L1358 1065H1735L1683 868H1305L1234 605H1611L1559 406H1181L1073 1H869L976 406H701L593 1H389ZM755 605H1029L1100 868H825L755 605Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 1230,
    d: "M518 -199V35H727V-199H518ZM518 1404V1639H727V1404H518ZM633 -30Q483 -30 365 24T172 177T73 413L280 446Q310 318 408 243T643 167Q779 167 864 232T950 398Q950 470 907 515T765 591L427 695Q127 788 127 1055Q127 1181 187 1274T358 1418T615 1469Q756 1467 865 1417T1047 1273T1148 1047L935 1009Q921 1086 877 1145T765 1237T613 1271Q534 1273 472 1247T373 1173T336 1065Q336 999 387 953T548 874L813 797Q995 743 1076 652T1157 410Q1157 278 1092 180T908 26T633 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1801,
    d: "M320 0L180 140L1481 1440L1621 1299L320 0ZM1321 -30Q1222 -30 1141 18T1010 148T961 330Q961 428 1011 510T1143 641T1321 690Q1420 690 1502 642T1632 512T1681 330Q1681 230 1633 149T1502 19T1321 -30ZM1321 151Q1370 151 1410 175T1475 241T1500 330Q1500 378 1476 419T1411 484T1321 509Q1273 509 1233 485T1168 419T1143 330Q1143 282 1167 241T1232 176T1321 151ZM480 750Q381 750 299 798T169 928T120 1110Q120 1208 170 1290T302 1421T480 1470Q579 1470 660 1422T791 1292T840 1110Q840 1010 791 929T661 799T480 750ZM480 931Q528 931 569 955T634 1021T659 1110Q659 1158 635 1199T569 1264T480 1289Q432 1289 392 1265T326 1199T301 1110Q301 1062 326 1021T391 956T480 931Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1325,
    d: "M613 -30Q492 -30 387 5T211 117Q156 178 130 251T100 408Q100 489 123 565T198 702Q221 730 249 750T305 787Q241 857 208 920T175 1071Q175 1193 239 1290T414 1431Q465 1452 518 1459T621 1467Q711 1467 795 1441T939 1356Q977 1321 1003 1277T1044 1187L838 1139Q821 1187 782 1220Q749 1249 706 1259T619 1270Q548 1270 491 1243Q439 1218 413 1175T387 1070Q387 1016 406 983T457 914Q476 893 502 869T557 819L949 454Q951 476 952 501T953 549L952 736H1139V489Q1139 426 1136 376T1123 293L1303 126L1168 -19L1023 119Q977 73 920 42T805 -5Q756 -20 709 -25T613 -30ZM619 170Q659 170 693 174T758 192Q800 209 826 227T871 262L461 638Q430 627 404 610T358 569Q335 540 324 502T313 419Q313 371 328 332T369 261Q409 213 480 192T619 170Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 489,
    d: "M120 1080V1440H329V1080H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 888,
    d: "M649 -373Q533 -238 449 -69T321 287T280 660Q277 846 321 1032T449 1388T649 1693L805 1577Q685 1435 612 1286T505 980T471 660Q471 498 505 341T612 34T805 -257L649 -373Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 888,
    d: "M239 -373L83 -257Q202 -116 275 34T383 341T417 660Q417 823 383 979T276 1285T83 1577L239 1693Q355 1558 439 1389T567 1033T608 660Q611 474 567 288T439 -68T239 -373Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 911,
    d: "M293 745L141 855L293 1041L60 1106L118 1285L343 1197L331 1440H519L507 1197L733 1285L791 1106L557 1041L709 855L557 745L425 945L293 745Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 1147,
    d: "M490 267V637H120V805H490V1173H658V805H1027V637H658V267H490Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 581,
    d: "M120 -239L133 -146Q176 -149 200 -130T232 -77T235 0H120V241H341V-20Q341 -138 285 -198T120 -239Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 840,
    d: "M120 547V715H720V547H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 573,
    d: "M176 0V221H397V0H176Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 835,
    d: "M504 1440H715L331 0H120L504 1440Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 1284,
    d: "M642 -30Q495 -30 382 34T205 212T140 472V968Q140 1115 204 1228T382 1405T642 1470Q789 1470 902 1406T1079 1228T1144 968V472Q1144 325 1080 212T902 35T642 -30ZM642 170Q722 170 787 208T892 312T931 459V983Q931 1063 892 1128T788 1232T642 1271Q562 1271 497 1233T392 1129T353 983V459Q353 378 392 313T496 209T642 170Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 844,
    d: "M391 0V1210L120 1045V1278L391 1440H604V0H391Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 1174,
    d: "M100 1L101 187L728 749Q804 816 831 877T859 999Q859 1076 825 1137T731 1235T593 1271Q513 1271 451 1234T353 1134T319 1000H105Q105 1140 168 1245T343 1410T597 1470Q733 1470 841 1409T1011 1240T1074 996Q1074 897 1048 828T970 700T840 572L356 140L333 200H1074V1H100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 1144,
    d: "M543 -27Q436 -27 342 13T180 129T80 306L282 362Q311 269 383 220T543 171Q622 172 682 208T776 305T810 447Q810 567 736 645T541 723Q507 723 472 713T405 687L307 852L815 1301L837 1241H137V1440H1003V1241L581 835L579 903Q715 903 815 843T969 679T1024 447Q1024 309 960 202T787 34T543 -27Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 1205,
    d: "M750 0V251H100V449L568 1440H807L339 449H750V839H962V449H1105V251H962V0H750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 1167,
    d: "M567 -30Q456 -30 361 15T197 141T100 327L301 381Q318 317 359 270T457 198T573 172Q652 172 716 210T818 312T856 453Q856 532 818 596T715 697T573 735Q485 735 424 700T329 619L147 683L191 1440H968V1243H298L383 1322L348 755L307 808Q364 865 443 895T600 925Q734 925 839 863T1006 695T1067 453Q1067 319 998 210T815 35T567 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 1243,
    d: "M635 -30Q495 -30 383 36T206 219T140 483V942Q140 1099 205 1218T387 1403T656 1469Q770 1469 870 1426T1043 1298L890 1155Q849 1208 788 1239T656 1271Q566 1271 498 1229T392 1117T353 969V705L312 751Q374 832 466 879T663 926Q797 926 902 864T1068 694T1129 453Q1129 318 1062 209T882 35T635 -30ZM635 171Q713 171 777 209T879 311T917 453Q917 531 880 595T778 697T636 735Q558 735 494 697T391 595T353 453Q353 376 391 312T493 210T635 171Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 1046,
    d: "M215 0L721 1241H80V1440H946V1241L441 0H215Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 1203,
    d: "M601 -30Q460 -30 352 26T182 184T120 418Q120 542 178 645T351 807L347 735Q255 792 206 877T156 1069Q156 1192 213 1282T370 1421T601 1470Q731 1470 831 1421T988 1282T1045 1069Q1045 963 998 878T854 735L851 805Q965 749 1024 646T1083 418Q1083 285 1021 184T850 27T601 -30ZM601 169Q717 169 789 232T861 418Q861 540 790 604T601 669Q484 669 413 605T341 418Q341 296 413 233T601 169ZM601 869Q700 869 761 918T823 1069Q823 1170 762 1220T601 1271Q502 1271 440 1221T378 1069Q378 968 440 919T601 869Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 1243,
    d: "M608 1469Q747 1469 859 1403T1037 1220T1103 955V497Q1103 339 1038 221T856 36T587 -30Q473 -30 373 13T199 141L353 284Q394 231 456 199T587 167Q676 167 744 210T851 322T889 470V734L931 688Q869 607 777 560T580 513Q445 513 340 575T174 744T113 986Q113 1121 181 1230T361 1404T608 1469ZM608 1267Q530 1267 466 1230T363 1128T325 986Q325 908 363 844T465 741T607 703Q685 703 749 741T851 843T889 986Q889 1063 852 1127T750 1229T608 1267Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 656,
    d: "M220 140V361H441V140H220ZM221 719V940H442V719H221Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 661,
    d: "M220 -239L233 -146Q276 -149 300 -130T332 -77T335 0H220V241H441V-20Q441 -138 385 -198T220 -239ZM220 859V1080H441V859H220Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 1259,
    d: "M757 153L280 630L757 1107L887 977L533 630L887 283L757 153Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 1500,
    d: "M240 819V987H1260V819H240ZM240 453V621H1260V453H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 1259,
    d: "M503 153L372 283L727 630L372 977L503 1107L979 630L503 153Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1087,
    d: "M408 391Q408 463 419 526T463 646Q490 700 526 733T606 799T698 883Q738 927 751 972T765 1069Q765 1107 756 1140T726 1197Q694 1237 645 1253T543 1270Q495 1270 452 1257T379 1217Q348 1191 334 1153T320 1069H100Q108 1163 148 1245T256 1378Q314 1424 388 1446T536 1469Q642 1469 736 1436T894 1329Q940 1277 963 1211T987 1073Q987 978 947 897T843 749Q810 714 776 686T713 630T665 571Q638 525 634 489T630 391H408ZM409 0V242H630V0H409Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1821,
    d: "M909 -210Q746 -210 609 -156T371 -4T215 228T160 517Q160 703 217 847T377 1089T615 1239T906 1290Q1096 1290 1239 1231T1477 1071T1618 841T1660 570Q1655 376 1579 273T1343 169Q1258 169 1187 208T1088 323L1146 320Q1105 243 1034 212T889 181Q788 181 711 224T590 347T546 530Q546 637 592 715T716 837T892 880Q957 880 1027 853T1137 777L1096 725V852H1230L1227 493Q1227 416 1257 377T1346 338Q1398 338 1426 367T1466 448T1480 565Q1483 720 1434 826T1302 997T1118 1092T919 1122Q779 1122 670 1078T487 953T375 763T339 522Q343 392 386 288T506 110T688 -3T918 -42Q988 -42 1057 -27T1185 17L1242 -139Q1165 -175 1081 -192T909 -210ZM901 351Q972 351 1020 392T1068 531Q1068 620 1026 665T906 711Q815 711 770 663T725 531Q725 445 771 398T901 351Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1317,
    d: "M40 0L508 1440H809L1277 0H1060L629 1314H683L257 0H40ZM283 325V521H1035V325H283Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1250,
    d: "M140 0V1440H706Q843 1440 936 1384T1076 1240T1123 1053Q1123 934 1065 849T907 733L905 782Q1043 748 1117 650T1191 420Q1191 293 1141 199T994 53T760 0H140ZM352 199H728Q799 199 855 226T944 303T977 424Q977 489 949 541T867 624T741 655H352V199ZM352 852H703Q761 852 807 875T881 943T909 1051Q909 1135 853 1189T703 1243H352V852Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1461,
    d: "M741 -30Q525 -30 373 64T141 328T60 720Q60 943 140 1112T373 1375T741 1470Q990 1470 1153 1344T1381 1005L1169 948Q1127 1099 1020 1185T741 1271Q588 1271 486 1202T333 1009T281 720Q280 555 331 431T485 238T741 169Q912 169 1019 255T1169 492L1381 435Q1317 222 1154 96T741 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1381,
    d: "M140 0V1440H591Q611 1440 665 1439T770 1431Q939 1410 1054 1310T1229 1057T1288 720Q1288 536 1229 383T1055 130T770 9Q720 2 666 1T591 0H140ZM354 199H591Q625 199 672 201T755 209Q865 230 933 304T1034 488T1066 720Q1066 847 1033 955T932 1137T755 1231Q719 1238 672 1239T591 1241H354V199Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1160,
    d: "M140 0V1440H1060V1243H349V839H940V642H349V197H1060V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1033,
    d: "M140 0V1440H993V1231H349V825H873V615H349V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1446,
    d: "M729 -30Q584 -30 462 20T250 168T110 404T60 720Q60 953 145 1120T381 1378T729 1469Q983 1469 1134 1351T1341 1025L1129 987Q1085 1116 987 1193T741 1271Q588 1272 487 1203T334 1010T282 720Q281 555 332 432T485 239T741 169Q864 167 952 214T1093 354T1160 580H880V748H1382Q1384 730 1385 701T1386 663Q1386 463 1309 306T1085 60T729 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1419,
    d: "M140 0V1440H349V819H1069V1440H1279V0H1069V622H349V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 529,
    d: "M160 0V1440H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 977,
    d: "M414 -29Q256 -29 149 55T0 281L207 330Q221 263 278 216T407 168Q454 168 505 192T581 270Q598 306 601 352T604 461V1440H816V461Q816 397 816 347T806 253T769 162Q712 63 619 17T414 -29Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1259,
    d: "M140 0V1440H349V768L952 1440H1212L575 737L1259 0H991L349 688V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1051,
    d: "M160 0V1440H369V197H1021V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1701,
    d: "M140 0V1440H329L851 357L1370 1440H1561V1H1363V986L898 0H803L337 986V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1413,
    d: "M140 0V1440H352L1061 370V1440H1273V0H1061L352 1071V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1481,
    d: "M741 -30Q525 -30 373 64T141 328T60 720Q60 943 140 1112T373 1375T741 1470Q956 1470 1108 1376T1341 1112T1421 720Q1421 497 1341 328T1109 65T741 -30ZM741 169Q894 167 995 236T1148 430T1199 720Q1199 885 1148 1008T996 1201T741 1271Q588 1273 487 1204T334 1010T282 720Q281 555 332 432T485 239T741 169Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1254,
    d: "M140 0V1440H722Q743 1440 774 1439T833 1432Q953 1413 1033 1350T1154 1191T1194 979Q1194 862 1154 766T1034 607T833 525Q805 521 774 519T722 517H349V0H140ZM349 715H714Q734 715 758 717T805 724Q869 739 908 779T964 873T981 979Q981 1032 964 1084T908 1177T805 1233Q783 1239 759 1241T714 1243H349V715Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1481,
    d: "M1269 -29L867 371L1001 505L1401 105L1269 -29ZM741 -30Q525 -30 373 64T141 328T60 720Q60 943 140 1112T373 1375T741 1470Q956 1470 1108 1376T1341 1112T1421 720Q1421 497 1341 328T1109 65T741 -30ZM741 169Q894 167 995 236T1148 430T1199 720Q1199 885 1148 1008T996 1201T741 1271Q588 1273 487 1204T334 1010T282 720Q281 555 332 432T485 239T741 169Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1301,
    d: "M140 0V1440H722Q743 1440 774 1439T833 1432Q953 1413 1033 1350T1154 1191T1194 979Q1194 807 1106 683T842 527L757 517H349V0H140ZM982 0L698 586L909 640L1221 0H982ZM349 715H714Q734 715 758 717T805 724Q869 739 908 779T964 873T981 979Q981 1032 964 1084T908 1177T805 1233Q783 1239 759 1241T714 1243H349V715Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1287,
    d: "M662 -30Q507 -30 383 23T178 176T73 413L291 446Q324 314 429 241T674 167Q761 167 834 194T951 273T996 397Q996 436 983 466T946 518T889 557T815 586L446 695Q392 711 336 736T234 803T158 906T129 1056Q129 1189 197 1281T383 1421T645 1469Q791 1467 906 1417T1098 1274T1204 1047L980 1009Q965 1090 916 1148T796 1238T642 1271Q562 1273 496 1247T390 1174T350 1066Q350 1006 385 969T471 911T574 875L840 800Q890 786 953 763T1076 697T1175 586T1214 411Q1214 302 1170 220T1050 82T873 -2T662 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1207,
    d: "M499 0V1243H20V1440H1187V1243H708V0H499Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1428,
    d: "M714 -30Q545 -30 416 39T213 234T140 530V1439L352 1440V541Q352 449 383 379T466 262T582 191T714 167Q782 167 846 191T963 263T1045 380T1076 541V1440H1288V530Q1288 361 1215 235T1013 40T714 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1257,
    d: "M478 0L10 1440H227L626 211L1030 1440H1247L779 0H478Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1925,
    d: "M445 0L27 1440H246L549 351L852 1439L1072 1440L1375 351L1678 1440H1898L1479 0H1271L962 1077L653 0H445Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1278,
    d: "M20 0L511 729L33 1440H289L640 906L989 1440H1246L768 729L1258 0H1002L640 551L277 0H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1186,
    d: "M487 0V595L0 1440H244L593 835L942 1440H1186L699 595V0H487Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1294,
    d: "M100 0V33L835 1243H140V1440H1194V1406L463 198H1181V0H100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 836,
    d: "M280 -428V1788H696V1600H468V-240H696V-428H280Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 835,
    d: "M331 1440L715 0H504L120 1440H331Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 836,
    d: "M556 -428H140V-240H368V1600H140V1788H556V-428Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 1353,
    d: "M211 994L687 1472L1164 995L1034 864L687 1219L341 863L211 994Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1320,
    d: "M0 -233V-65H1320V-233H0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 1045,
    d: "M474 1600L332 1950H496L638 1600H474Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1139,
    d: "M445 -30Q325 -30 244 14T122 132T80 294Q80 376 109 438T195 543T335 614Q407 635 498 651T689 681T889 709L813 667Q815 794 760 855T569 917Q484 917 413 878T314 747L119 807Q159 946 271 1028T571 1110Q716 1110 823 1061T981 904Q1007 851 1013 792T1019 665V0H834V247L870 215Q803 91 700 31T445 -30ZM482 141Q571 141 635 172T738 253T789 355Q806 403 808 463T811 559L879 534Q780 519 699 507T553 484T436 456Q393 441 360 420T307 369T287 296Q287 254 308 219T372 162T482 141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1216,
    d: "M647 -30Q492 -30 387 45T228 250T174 541Q174 703 227 832T385 1035T643 1110Q795 1110 905 1036T1076 833T1136 541Q1136 379 1077 250T908 45T647 -30ZM139 0V1440H349V777H325V0H139ZM618 159Q718 159 783 210T881 347T914 541Q914 647 882 733T782 870T611 921Q513 921 450 873T356 739T325 541Q325 429 355 343T450 208T618 159Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1137,
    d: "M602 -30Q436 -30 320 44T143 247T80 540Q81 707 144 835T324 1037T605 1110Q782 1110 907 1022T1073 781L865 721Q834 812 764 862T602 913Q499 913 433 865T335 732T302 540Q303 373 378 270T602 167Q703 167 765 213T861 347L1073 297Q1020 139 898 55T602 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1217,
    d: "M569 -30Q418 -30 309 45T140 249T80 541Q80 704 140 832T310 1035T573 1110Q726 1110 830 1036T988 832T1042 541Q1042 379 988 250T829 46T569 -30ZM598 159Q701 159 766 208T861 343T891 541Q891 653 861 739T767 873T605 921Q501 921 434 870T335 733T302 541Q302 434 334 348T432 210T598 159ZM891 0V777H867V1440H1077V0H891Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1193,
    d: "M619 -30Q458 -30 337 40T148 237T80 531Q80 708 146 838T332 1039T609 1110Q774 1110 890 1034T1063 816T1109 481H900V557Q898 745 829 835T617 925Q460 925 381 826T302 540Q302 362 381 265T609 167Q707 167 778 211T890 339L1095 274Q1032 129 904 50T619 -30ZM234 481V644H1005V481H234Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 741,
    d: "M239 0V1118Q239 1159 242 1205T259 1297T308 1381Q349 1426 398 1445T495 1467T585 1470H721V1298H595Q521 1298 485 1262T448 1158V0H239ZM60 912V1080H721V912H60Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1216,
    d: "M585 -510Q498 -510 417 -483T268 -404T157 -274L350 -176Q385 -245 450 -277T587 -309Q676 -309 739 -278T834 -183T866 -27V275H891V1080H1076V-29Q1076 -72 1073 -111T1062 -189Q1039 -298 975 -369T811 -475T585 -510ZM569 -30Q418 -30 309 45T140 249T80 541Q80 704 140 832T310 1035T573 1110Q726 1110 830 1036T988 832T1042 541Q1042 379 988 250T829 46T569 -30ZM598 159Q701 159 766 208T861 343T891 541Q891 653 861 739T767 873T605 921Q501 921 434 870T335 733T302 541Q302 434 334 348T432 210T598 159Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1230,
    d: "M898 0V531Q898 594 888 660T848 784T765 876T625 911Q569 911 519 893T432 833T373 725T351 562L221 611Q221 758 276 870T434 1046T683 1109Q795 1109 871 1073T994 979T1067 851T1101 716T1110 600V0H898ZM139 0V1440H326V663H351V0H139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 529,
    d: "M160 1257V1460H369V1257H160ZM160 0V1080H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 551,
    d: "M-20 -480V-282H35Q118 -282 156 -242T195 -119V1080H405V-204Q405 -336 333 -408T125 -480H-20ZM195 1257V1460H405V1257H195Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1048,
    d: "M139 0L140 1440H352V560L776 1080H1042L594 540L1088 0H804L352 520V0H139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 529,
    d: "M160 0V1470H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1764,
    d: "M1434 0L1435 673Q1435 790 1375 855T1217 921Q1157 921 1108 894T1028 812T997 675L896 726Q894 840 944 926T1082 1059T1277 1107Q1452 1107 1548 1002T1644 723L1643 0H1434ZM139 0V1080H325V768H349V0H139ZM787 0L788 669Q788 787 729 854T569 921Q470 921 410 853T349 675L249 739Q249 845 300 928T438 1059T635 1107Q750 1107 831 1059T954 923T997 721L996 0H787Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1230,
    d: "M898 0V531Q898 594 888 660T848 784T765 876T625 911Q569 911 519 893T432 833T373 725T351 562L221 611Q221 758 276 870T434 1046T683 1109Q795 1109 871 1073T994 979T1067 851T1101 716T1110 600V0H898ZM139 0V1080H326V768H351V0H139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1219,
    d: "M609 -30Q447 -30 328 43T145 244T80 541Q80 710 146 838T331 1038T609 1110Q771 1110 890 1037T1074 836T1139 541Q1139 372 1074 244T889 43T609 -30ZM609 167Q764 167 840 271T917 541Q917 710 840 811T609 913Q504 913 436 866T335 735T302 541Q302 371 380 269T609 167Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1216,
    d: "M647 -30Q492 -30 387 45T228 250T174 541Q174 703 227 832T385 1035T643 1110Q795 1110 905 1036T1076 833T1136 541Q1136 379 1077 250T908 45T647 -30ZM139 -480V1080H325V303H349V-480H139ZM618 159Q718 159 783 210T881 347T914 541Q914 647 882 733T782 870T611 921Q513 921 450 873T356 739T325 541Q325 429 355 343T450 208T618 159Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1217,
    d: "M569 -30Q418 -30 309 45T140 249T80 541Q80 704 140 832T310 1035T573 1110Q726 1110 830 1036T988 832T1042 541Q1042 379 988 250T829 46T569 -30ZM598 159Q701 159 766 208T861 343T891 541Q891 653 861 739T767 873T605 921Q501 921 434 870T335 733T302 541Q302 434 334 348T432 210T598 159ZM867 -480V303H891V1080H1077V-480H867Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 773,
    d: "M140 0V1080H326V818L300 852Q320 904 352 947T426 1019Q467 1049 517 1065T621 1085T723 1080V884Q670 898 606 892T487 851Q436 818 407 771T364 667T351 545V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 1072,
    d: "M553 -29Q356 -29 232 58T80 303L294 336Q314 252 386 204T567 155Q665 155 720 195T776 305Q776 346 757 371T675 420T486 477Q347 513 266 554T150 651T115 786Q115 884 167 957T313 1070T535 1110Q659 1110 756 1071T913 961T985 793L771 754Q760 832 698 877T537 926Q442 930 383 895T324 797Q324 761 346 736T434 688T626 633Q762 598 842 556T956 455T991 313Q991 153 875 62T553 -29Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 845,
    d: "M758 0Q656 -20 558 -17T383 21T267 131Q232 198 230 267T227 425V1380H437V435Q437 370 438 322T459 241Q495 179 573 171T758 177V0ZM20 912V1080H758V912H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1230,
    d: "M547 -29Q435 -29 359 7T236 101T163 229T129 364T120 480V1080H332V549Q332 486 342 420T382 296T465 204T605 169Q661 169 711 187T798 247T857 355T879 518L1009 469Q1009 322 954 210T796 34T547 -29ZM904 0V312H879V1080H1090V0H904Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1076,
    d: "M432 0L40 1080H251L538 262L825 1080H1036L644 0H432Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1581,
    d: "M370 0L40 1081L247 1080L473 339L701 1080H881L1109 339L1335 1080H1541L1211 0H1043L791 782L538 0H370Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1090,
    d: "M20 0L424 546L29 1080H277L546 709L812 1080H1060L665 546L1070 0H821L546 383L269 0H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1097,
    d: "M286 -480L495 89L498 -79L27 1080H245L597 185H533L869 1080H1081L485 -480H286Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 1065,
    d: "M40 0V33L653 893H96V1080H985V1046L373 187H955V0H40Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 878,
    d: "M664 -428Q543 -428 471 -356T398 -163V455Q398 480 384 501L297 624Q280 650 280 680T297 736L384 859Q398 882 398 905V1522Q398 1642 470 1715T664 1788H795V1589H678Q644 1589 621 1566T597 1509V905Q597 817 546 745L499 680L546 615Q597 543 597 455V-149Q597 -183 620 -207T678 -231H795V-428H664Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 569,
    d: "M180 0V1440H389V0H180Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 878,
    d: "M214 -428H83V-231H201Q234 -231 257 -207T281 -149V455Q281 543 333 615L379 680L333 745Q281 817 281 905V1509Q281 1542 258 1565T201 1589H83V1788H214Q335 1788 407 1715T480 1522V905Q480 882 494 859L581 736Q599 711 599 681T581 624L494 501Q480 480 480 455V-163Q480 -283 408 -355T214 -428Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 1396,
    d: "M925 428Q860 428 801 456T687 520T584 584T493 612Q445 612 429 567T431 461H239Q213 564 231 648T309 782T470 832Q534 832 594 804T709 740T812 675T903 647Q948 647 966 692T965 801H1157Q1182 698 1165 614T1087 479T925 428Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 400
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 689,
    d: "M240 1080H449V877H240V1080ZM240 720H449V-360H240V720Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 1137,
    d: "M527 -59V125Q385 142 285 218T133 416T80 690Q81 843 134 964T287 1161T527 1254V1440H695V1253Q838 1231 938 1147T1073 931L865 871Q834 962 764 1012T602 1063Q499 1063 433 1015T335 882T302 690Q303 523 378 420T602 317Q703 317 765 363T861 497L1073 447Q1026 311 930 230T695 127V-59H527Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    horizAdvX: 1142,
    d: "M73 0V197H125Q186 197 228 241T271 345V1088Q271 1198 324 1284T467 1420T669 1470Q770 1470 846 1425T976 1299T1069 1109L879 1047Q846 1155 797 1213T669 1271Q586 1271 536 1218T485 1079L483 197H988V0H73ZM73 626V825H807V626H73Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    horizAdvX: 1321,
    d: "M661 196Q553 196 458 237T291 350T178 518T137 722Q137 830 178 925T291 1092T458 1205T661 1246Q770 1246 865 1205T1032 1092T1146 925T1187 722Q1187 613 1146 518T1033 351T865 237T661 196ZM200 120L60 260L293 493L435 353L200 120ZM294 945L60 1179L200 1320L433 1087L294 945ZM1121 120L888 353L1028 493L1261 260L1121 120ZM661 376Q756 376 834 423T959 549T1005 720Q1005 815 958 893T833 1018T661 1065Q565 1065 487 1019T363 894T317 720Q317 627 363 549T487 423T661 376ZM1029 947L888 1087L1121 1320L1261 1179L1029 947Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    horizAdvX: 1186,
    d: "M193 521V689H993V521H193ZM193 207V375H993V207H193ZM487 0V595L0 1440H244L593 835L942 1440H1186L699 595V0H487Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 569,
    d: "M180 651V1440H389V651H180ZM180 -376V413H389V-376H180Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1072,
    d: "M554 -289Q445 -289 351 -255T193 -147T107 43L321 76Q335 14 373 -26T463 -85T567 -105Q616 -105 659 -89T729 -40T756 45Q756 93 727 121T634 169T466 217Q348 248 265 285T139 377T95 513Q95 612 153 674T300 764T481 787L497 706Q408 680 356 641T304 541Q304 491 341 463T447 416T606 373Q722 341 803 304T928 209T971 55Q971 -57 916 -133T767 -249T554 -289ZM611 260L607 341Q649 348 690 370T757 430T783 518Q783 567 754 594T660 642T493 690Q374 721 291 758T165 852T121 999Q121 1110 180 1182T329 1288T515 1323Q618 1323 708 1286T858 1178T932 1006L718 967Q707 1029 677 1067T602 1123T507 1141Q459 1141 419 1126T355 1083T331 1014Q331 963 369 935T476 889T633 846Q748 815 829 778T954 684T998 534Q998 434 950 367T814 272T611 260Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 1083,
    d: "M643 1621V1821H843V1621H643ZM240 1621V1821H440V1621H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1717,
    d: "M858 -97Q693 -97 548 -35T294 137T122 392T60 702Q60 868 122 1012T293 1267T548 1439T858 1501Q1025 1501 1169 1439T1423 1267T1595 1013T1657 702Q1657 537 1595 392T1424 138T1170 -34T858 -97ZM872 277Q775 277 703 309T575 409Q523 475 502 549T480 703Q481 786 503 860T575 995Q630 1062 704 1095T880 1128Q936 1128 983 1117T1079 1075Q1132 1044 1170 994T1225 878L1062 833Q1052 862 1034 888T989 935Q965 956 935 965T871 974Q820 974 779 954T707 895Q677 857 666 806T655 704Q655 650 667 600T707 511Q735 473 777 453T873 433Q947 433 993 469Q1017 489 1032 512T1059 564L1225 526Q1206 468 1173 422T1096 343Q1051 311 998 294T872 277ZM859 102Q983 102 1091 148T1282 277T1411 469T1458 703Q1458 827 1412 935T1283 1126T1092 1255T859 1302Q734 1302 625 1256T434 1127T305 936T258 703Q258 578 304 469T433 278T625 149T859 102Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 636,
    d: "M261 540Q173 540 127 588T80 703Q80 762 109 802T203 865Q252 881 324 891T481 915L438 882Q440 943 415 971T327 1000Q291 1000 257 983T210 924L99 959Q119 1027 176 1068T328 1110Q400 1110 454 1087T536 1010Q550 981 553 952T556 886V555H451V672L467 651Q430 593 382 567T261 540ZM285 636Q346 636 381 667T424 726Q434 749 435 779T437 827L475 816Q392 802 344 795T264 776Q232 764 215 748T198 705Q198 675 220 656T285 636Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1139,
    d: "M897 100L547 541L897 981L1012 890L733 541L1012 191L897 100ZM510 100L160 541L510 981L625 890L347 541L625 191L510 100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    horizAdvX: 1200,
    d: "M912 378V617H120V785H1080V378H912Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 840,
    d: "M120 547V715H720V547H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1290,
    d: "M645 555Q540 555 449 594T288 703T180 864T140 1061Q140 1165 179 1256T288 1417T448 1526T645 1565Q749 1565 840 1526T1001 1418T1110 1257T1150 1061Q1150 956 1111 865T1002 704T841 595T645 555ZM646 701Q744 701 826 750T957 881T1006 1061Q1006 1161 957 1242T826 1372T646 1421Q546 1421 464 1373T334 1243T285 1061Q285 963 333 881T464 750T646 701ZM480 827V1298H681Q752 1298 795 1255T841 1143Q841 1102 820 1065T757 1005L845 827H749L671 990H564V827H480ZM564 1069H683Q713 1069 734 1090T755 1143Q755 1179 735 1198T683 1218H564V1069Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 1003,
    d: "M240 1680V1847H763V1680H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 900,
    d: "M420 750Q321 750 239 798T109 928T60 1110Q60 1208 110 1290T242 1421T420 1470Q519 1470 600 1422T731 1292T780 1110Q780 1010 731 929T601 799T420 750ZM420 931Q468 931 509 955T574 1021T599 1110Q599 1158 575 1199T509 1264T420 1289Q372 1289 332 1265T266 1199T241 1110Q241 1062 266 1021T331 956T420 931Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    horizAdvX: 1200,
    d: "M517 440V677H120V845H517V1080H685V845H1080V677H685V440H517ZM120 139V307H1080V139H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 816,
    d: "M100 540L101 664L489 1013Q535 1054 553 1090T571 1162Q571 1233 527 1280T412 1327Q364 1327 326 1305T267 1245T247 1164H102Q102 1253 142 1319T252 1423T415 1460Q501 1460 569 1422T676 1316T716 1161Q716 1098 699 1055T648 974T564 893L268 628L251 673H716V540H100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 799,
    d: "M373 519Q272 519 191 576T80 732L217 769Q234 712 277 683T373 653Q444 654 489 700T535 817Q535 889 490 936T373 983Q352 983 331 977T291 961L225 1072L545 1352L562 1306H116V1440H665V1305L402 1053L399 1103Q486 1103 548 1065T645 962T679 817Q679 731 638 664T528 558T373 519Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 1045,
    d: "M570 1600H406L549 1950H713L570 1600Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    horizAdvX: 1249,
    d: "M139 -480V1080H351V549Q351 486 361 420T401 296T483 204T623 169Q680 169 729 187T817 247T876 355T898 518V1080H1109V0H923V133Q864 54 773 13T566 -29Q490 -29 430 -7T325 56V-480H139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1377,
    d: "M678 -282V517H585Q574 517 543 518T475 525Q356 543 276 606T154 765T113 979Q113 1094 153 1190T274 1350T475 1432Q512 1438 543 1439T585 1440H887V-282H678ZM1054 -282V1440H1263V-282H1054Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 507,
    d: "M257 497Q199 497 160 535T120 630Q120 688 159 725T257 763Q309 763 348 726T387 630Q387 573 348 535T257 497Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 816,
    d: "M375 -482Q336 -482 303 -472T240 -447L288 -319Q331 -333 357 -333Q390 -333 407 -314T425 -271Q425 -230 386 -212T294 -177L366 27L499 29L456 -95Q512 -122 544 -167T577 -277Q577 -367 517 -424T375 -482Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 673,
    d: "M289 540V1286L120 1183V1339L289 1440H433V540H289Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 698,
    d: "M349 540Q227 540 154 620T80 826Q80 952 154 1031T349 1110Q471 1110 544 1030T618 826Q618 699 544 620T349 540ZM348 653Q420 653 455 701T491 826Q491 904 456 950T348 997Q276 997 242 950T208 825Q208 746 243 700T348 653Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1139,
    d: "M242 100L127 191L405 541L127 890L242 981L592 541L242 100ZM629 100L513 191L792 541L513 890L629 981L979 541L629 100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 2029,
    d: "M289 540V1286L120 1183V1339L289 1440H433V540H289ZM1561 0V153H1157V286L1448 900H1609L1319 286H1561V525H1703V286H1789V153H1703V0H1561ZM476 0L349 96L1356 1449L1483 1353L476 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 1975,
    d: "M289 540V1286L120 1183V1339L289 1440H433V540H289ZM1259 0V124L1648 473Q1694 514 1711 550T1729 622Q1729 693 1685 740T1571 787Q1522 787 1485 765T1426 705T1406 624H1261Q1261 713 1300 780T1410 883T1573 920Q1659 920 1727 882T1835 776T1875 621Q1875 558 1858 515T1807 434T1723 353L1427 88L1409 133H1875V0H1259ZM476 0L349 96L1356 1449L1483 1353L476 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 2023,
    d: "M373 519Q272 519 191 576T80 732L217 769Q234 712 277 683T373 653Q444 654 489 700T535 817Q535 889 490 936T373 983Q352 983 331 977T291 961L225 1072L545 1352L562 1306H116V1440H665V1305L402 1053L399 1103Q486 1103 548 1065T645 962T679 817Q679 731 638 664T528 558T373 519ZM1675 0V153H1271V286L1562 900H1723L1433 286H1675V525H1817V286H1903V153H1817V0H1675ZM602 0L475 96L1482 1449L1609 1353L602 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 1087,
    d: "M679 689Q679 617 668 554T624 434Q597 380 560 347T480 281T389 197Q350 153 336 109T322 11Q322 -27 331 -59T361 -117Q393 -157 442 -173T544 -190Q593 -190 636 -177T707 -137Q739 -111 753 -73T767 11H987Q979 -82 939 -164T831 -298Q773 -343 699 -366T551 -389Q445 -389 351 -356T193 -249Q148 -197 124 -130T100 7Q100 103 140 184T244 331Q277 366 310 394T373 450T421 509Q449 556 453 592T457 689H679ZM677 1080V838H457V1080H677Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1317,
    d: "M555 1600L413 1950H577L719 1600H555ZM1277 0H1060L633 1314H688L257 0H40L508 1440H809L1277 0ZM1034 325H282V521H1034V325Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1317,
    d: "M761 1600H597L740 1950H904L761 1600ZM40 0L508 1440H809L1277 0H1060L629 1314H683L257 0H40ZM283 325V521H1035V325H283Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1317,
    d: "M308 1600L567 1900H747L1005 1600H805L657 1777L508 1600H308ZM40 0L508 1440H809L1277 0H1060L629 1314H683L257 0H40ZM283 325V521H1035V325H283Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1317,
    d: "M820 1654Q774 1654 732 1674T651 1719T578 1765T514 1785Q480 1785 469 1753T469 1677H333Q307 1788 348 1864T497 1941Q543 1941 585 1921T667 1876T740 1830T804 1810Q837 1810 849 1841T849 1919H985Q1012 1810 970 1732T820 1654ZM40 0L508 1440H809L1277 0H1060L629 1314H683L257 0H40ZM283 325V521H1035V325H283Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1317,
    d: "M761 1621V1821H961V1621H761ZM358 1621V1821H558V1621H358ZM40 0L508 1440H809L1277 0H1060L629 1314H683L257 0H40ZM283 325V521H1035V325H283Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1317,
    d: "M659 1553Q592 1553 537 1586T448 1675T415 1798Q415 1866 448 1921T536 2009T659 2043Q727 2043 782 2010T871 1921T904 1798Q904 1731 871 1675T783 1586T659 1553ZM659 1688Q706 1688 737 1720T769 1798Q769 1844 738 1876T659 1908Q614 1908 582 1876T549 1798Q549 1753 581 1721T659 1688ZM40 0L508 1440H809L1277 0H1060L629 1314H683L257 0H40ZM283 325V521H1035V325H283Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 1863,
    d: "M40 0L508 1440H917V1243H584L683 1314L257 0H40ZM283 325V521H1001V325H283ZM843 0V1440H1763V1243H1053V839H1643V642H1053V197H1763V0H843Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1461,
    d: "M721 -482Q682 -482 649 -472T587 -447L635 -319Q677 -333 703 -333Q736 -333 754 -314T772 -271Q772 -230 733 -212T641 -177L713 27L846 29L803 -95Q859 -122 891 -167T924 -277Q924 -367 864 -424T721 -482ZM741 -30Q525 -30 373 64T141 328T60 720Q60 943 140 1112T373 1375T741 1470Q990 1470 1153 1344T1381 1005L1169 948Q1127 1099 1020 1185T741 1271Q588 1271 486 1202T333 1009T281 720Q280 555 331 431T485 238T741 169Q912 169 1019 255T1169 492L1381 435Q1317 222 1154 96T741 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1160,
    d: "M542 1600L399 1950H563L706 1600H542ZM140 0V1440H1060V1243H349V839H940V642H349V197H1060V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1160,
    d: "M708 1600H544L687 1950H851L708 1600ZM140 0V1440H1060V1243H349V839H940V642H349V197H1060V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1160,
    d: "M239 1600L497 1900H677L936 1600H736L587 1777L439 1600H239ZM140 0V1440H1060V1243H349V839H940V642H349V197H1060V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1160,
    d: "M690 1621V1821H890V1621H690ZM287 1621V1821H487V1621H287ZM140 0V1440H1060V1243H349V839H940V642H349V197H1060V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 529,
    d: "M179 1600L37 1950H201L343 1600H179ZM160 0V1440H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 529,
    d: "M350 1600H186L329 1950H493L350 1600ZM160 0V1440H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 529,
    d: "M-87 1600L172 1900H352L611 1600H411L262 1777L113 1600H-87ZM160 0V1440H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 529,
    d: "M366 1621V1821H566V1621H366ZM-37 1621V1821H163V1621H-37ZM160 0V1440H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1379,
    d: "M20 637V805H680V637H20ZM138 0V1440H589Q609 1440 663 1439T768 1431Q937 1410 1052 1310T1227 1057T1286 720Q1286 536 1227 383T1053 130T768 9Q718 2 664 1T589 0H138ZM352 199H589Q623 199 670 201T753 209Q863 230 931 304T1032 488T1064 720Q1064 847 1031 955T930 1137T753 1231Q717 1238 670 1239T589 1241H352V199Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1413,
    d: "M891 1604Q846 1604 804 1624T722 1669T649 1715T585 1735Q551 1735 540 1703T541 1627H405Q378 1738 420 1814T569 1891Q615 1891 657 1871T738 1826T811 1780T875 1760Q908 1760 920 1791T920 1869H1056Q1083 1760 1041 1682T891 1604ZM140 0V1440H352L1061 370V1440H1273V0H1061L352 1071V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1481,
    d: "M643 1600L500 1950H664L807 1600H643ZM741 -30Q525 -30 373 64T141 328T60 720Q60 943 140 1112T373 1375T741 1470Q956 1470 1108 1376T1341 1112T1421 720Q1421 497 1341 328T1109 65T741 -30ZM741 169Q894 167 995 236T1148 430T1199 720Q1199 885 1148 1008T996 1201T741 1271Q588 1273 487 1204T334 1010T282 720Q281 555 332 432T485 239T741 169Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1481,
    d: "M835 1600H671L814 1950H978L835 1600ZM741 -30Q525 -30 373 64T141 328T60 720Q60 943 140 1112T373 1375T741 1470Q956 1470 1108 1376T1341 1112T1421 720Q1421 497 1341 328T1109 65T741 -30ZM741 169Q894 167 995 236T1148 430T1199 720Q1199 885 1148 1008T996 1201T741 1271Q588 1273 487 1204T334 1010T282 720Q281 555 332 432T485 239T741 169Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1481,
    d: "M389 1600L648 1900H828L1087 1600H887L738 1777L589 1600H389ZM741 -30Q525 -30 373 64T141 328T60 720Q60 943 140 1112T373 1375T741 1470Q956 1470 1108 1376T1341 1112T1421 720Q1421 497 1341 328T1109 65T741 -30ZM741 169Q894 167 995 236T1148 430T1199 720Q1199 885 1148 1008T996 1201T741 1271Q588 1273 487 1204T334 1010T282 720Q281 555 332 432T485 239T741 169Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1481,
    d: "M741 -30Q525 -30 373 64T141 328T60 720Q60 943 140 1112T373 1375T741 1470Q956 1470 1108 1376T1341 1112T1421 720Q1421 497 1341 328T1109 65T741 -30ZM741 169Q894 167 995 236T1148 430T1199 720Q1199 885 1148 1008T996 1201T741 1271Q588 1273 487 1204T334 1010T282 720Q281 555 332 432T485 239T741 169ZM915 1604Q869 1604 827 1624T746 1669T673 1715T609 1735Q575 1735 564 1703T564 1627H428Q402 1738 443 1814T592 1891Q638 1891 680 1871T762 1826T835 1780T899 1760Q932 1760 944 1791T944 1869H1080Q1107 1760 1065 1682T915 1604Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1481,
    d: "M842 1621V1821H1042V1621H842ZM439 1621V1821H639V1621H439ZM741 -30Q525 -30 373 64T141 328T60 720Q60 943 140 1112T373 1375T741 1470Q956 1470 1108 1376T1341 1112T1421 720Q1421 497 1341 328T1109 65T741 -30ZM741 169Q894 167 995 236T1148 430T1199 720Q1199 885 1148 1008T996 1201T741 1271Q588 1273 487 1204T334 1010T282 720Q281 555 332 432T485 239T741 169Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    horizAdvX: 1001,
    d: "M762 340L500 602L238 340L120 459L381 721L121 982L240 1100L500 840L761 1100L880 982L619 721L881 459L762 340Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1481,
    d: "M215 -26L66 107L238 298L268 326L1090 1235L1105 1257L1291 1464L1440 1331L1237 1105L1214 1087L391 175L373 150L215 -26ZM741 -30Q525 -30 373 64T141 328T60 720Q60 943 140 1112T373 1375T741 1470Q956 1470 1108 1376T1341 1112T1421 720Q1421 497 1341 328T1109 65T741 -30ZM741 169Q894 167 995 236T1148 430T1199 720Q1199 885 1148 1008T996 1201T741 1271Q588 1273 487 1204T334 1010T282 720Q281 555 332 432T485 239T741 169Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1428,
    d: "M651 1600L508 1950H672L815 1600H651ZM714 -30Q545 -30 416 39T213 234T140 530V1439L352 1440V541Q352 449 383 379T466 262T582 191T714 167Q782 167 846 191T963 263T1045 380T1076 541V1440H1288V530Q1288 361 1215 235T1013 40T714 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1428,
    d: "M787 1600H623L766 1950H930L787 1600ZM714 -30Q545 -30 416 39T213 234T140 530V1439L352 1440V541Q352 449 383 379T466 262T582 191T714 167Q782 167 846 191T963 263T1045 380T1076 541V1440H1288V530Q1288 361 1215 235T1013 40T714 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1428,
    d: "M363 1600L621 1900H801L1060 1600H860L711 1777L563 1600H363ZM714 -30Q545 -30 416 39T213 234T140 530V1439L352 1440V541Q352 449 383 379T466 262T582 191T714 167Q782 167 846 191T963 263T1045 380T1076 541V1440H1288V530Q1288 361 1215 235T1013 40T714 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1428,
    d: "M815 1621V1821H1015V1621H815ZM413 1621V1821H613V1621H413ZM714 -30Q545 -30 416 39T213 234T140 530V1439L352 1440V541Q352 449 383 379T466 262T582 191T714 167Q782 167 846 191T963 263T1045 380T1076 541V1440H1288V530Q1288 361 1215 235T1013 40T714 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1186,
    d: "M665 1600H501L644 1950H808L665 1600ZM487 0V595L0 1440H244L593 835L942 1440H1186L699 595V0H487Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1237,
    d: "M140 0V1440H352V1181H711Q787 1181 860 1157Q921 1137 975 1100T1067 1012Q1119 952 1147 876T1177 720Q1178 643 1150 569T1075 435Q1013 355 917 308T711 260H352V0H140ZM352 457H710Q762 457 815 483T906 557Q933 592 949 634T963 720Q962 770 945 816T893 898Q859 935 810 959T710 983H352V457Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1245,
    d: "M667 -29Q608 -29 565 -23T483 0V205Q516 193 554 185T641 177Q764 177 838 239T913 422Q913 547 819 609T572 672V857Q637 863 686 888T764 958T792 1068Q792 1165 728 1219T571 1273Q508 1273 456 1247T376 1159Q363 1130 358 1090T352 1005V0H139V1061Q139 1105 143 1141T159 1211Q189 1301 250 1358T393 1443T571 1470Q694 1470 792 1420T948 1280T1005 1071Q1005 982 971 909T866 793Q916 778 962 746T1045 665T1103 555T1125 419Q1125 212 1008 92T667 -29Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1139,
    d: "M501 1240L359 1590H523L665 1240H501ZM445 -30Q325 -30 244 14T122 132T80 294Q80 376 109 438T195 543T335 614Q407 635 498 651T689 681T889 709L813 667Q815 794 760 855T569 917Q484 917 413 878T314 747L119 807Q159 946 271 1028T571 1110Q716 1110 823 1061T981 904Q1007 851 1013 792T1019 665V0H834V247L870 215Q803 91 700 31T445 -30ZM482 141Q571 141 635 172T738 253T789 355Q806 403 808 463T811 559L879 534Q780 519 699 507T553 484T436 456Q393 441 360 420T307 369T287 296Q287 254 308 219T372 162T482 141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1139,
    d: "M668 1240H504L646 1590H810L668 1240ZM445 -30Q325 -30 244 14T122 132T80 294Q80 376 109 438T195 543T335 614Q407 635 498 651T689 681T889 709L813 667Q815 794 760 855T569 917Q484 917 413 878T314 747L119 807Q159 946 271 1028T571 1110Q716 1110 823 1061T981 904Q1007 851 1013 792T1019 665V0H834V247L870 215Q803 91 700 31T445 -30ZM482 141Q571 141 635 172T738 253T789 355Q806 403 808 463T811 559L879 534Q780 519 699 507T553 484T436 456Q393 441 360 420T307 369T287 296Q287 254 308 219T372 162T482 141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1139,
    d: "M235 1240L493 1540H673L932 1240H732L583 1417L435 1240H235ZM445 -30Q325 -30 244 14T122 132T80 294Q80 376 109 438T195 543T335 614Q407 635 498 651T689 681T889 709L813 667Q815 794 760 855T569 917Q484 917 413 878T314 747L119 807Q159 946 271 1028T571 1110Q716 1110 823 1061T981 904Q1007 851 1013 792T1019 665V0H834V247L870 215Q803 91 700 31T445 -30ZM482 141Q571 141 635 172T738 253T789 355Q806 403 808 463T811 559L879 534Q780 519 699 507T553 484T436 456Q393 441 360 420T307 369T287 296Q287 254 308 219T372 162T482 141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1139,
    d: "M761 1244Q715 1244 673 1264T592 1309T519 1355T455 1375Q420 1375 409 1343T410 1267H274Q247 1378 289 1454T438 1531Q484 1531 526 1511T608 1466T681 1420T745 1400Q777 1400 790 1431T789 1509H925Q953 1400 911 1322T761 1244ZM445 -30Q325 -30 244 14T122 132T80 294Q80 376 109 438T195 543T335 614Q407 635 498 651T689 681T889 709L813 667Q815 794 760 855T569 917Q484 917 413 878T314 747L119 807Q159 946 271 1028T571 1110Q716 1110 823 1061T981 904Q1007 851 1013 792T1019 665V0H834V247L870 215Q803 91 700 31T445 -30ZM482 141Q571 141 635 172T738 253T789 355Q806 403 808 463T811 559L879 534Q780 519 699 507T553 484T436 456Q393 441 360 420T307 369T287 296Q287 254 308 219T372 162T482 141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1139,
    d: "M691 1261V1461H891V1261H691ZM288 1261V1461H488V1261H288ZM445 -30Q325 -30 244 14T122 132T80 294Q80 376 109 438T195 543T335 614Q407 635 498 651T689 681T889 709L813 667Q815 794 760 855T569 917Q484 917 413 878T314 747L119 807Q159 946 271 1028T571 1110Q716 1110 823 1061T981 904Q1007 851 1013 792T1019 665V0H834V247L870 215Q803 91 700 31T445 -30ZM482 141Q571 141 635 172T738 253T789 355Q806 403 808 463T811 559L879 534Q780 519 699 507T553 484T436 456Q393 441 360 420T307 369T287 296Q287 254 308 219T372 162T482 141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1139,
    d: "M583 1193Q516 1193 461 1226T372 1315T338 1438Q338 1506 371 1561T460 1649T583 1683Q651 1683 706 1650T795 1561T828 1438Q828 1371 795 1315T707 1226T583 1193ZM583 1328Q629 1328 661 1360T693 1438Q693 1484 661 1516T583 1548Q538 1548 506 1516T473 1438Q473 1393 505 1361T583 1328ZM445 -30Q325 -30 244 14T122 132T80 294Q80 376 109 438T195 543T335 614Q407 635 498 651T689 681T889 709L813 667Q815 794 760 855T569 917Q484 917 413 878T314 747L119 807Q159 946 271 1028T571 1110Q716 1110 823 1061T981 904Q1007 851 1013 792T1019 665V0H834V247L870 215Q803 91 700 31T445 -30ZM482 141Q571 141 635 172T738 253T789 355Q806 403 808 463T811 559L879 534Q780 519 699 507T553 484T436 456Q393 441 360 420T307 369T287 296Q287 254 308 219T372 162T482 141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1876,
    d: "M1330 -30Q1173 -30 1059 42T882 241T820 531Q820 704 881 834T1054 1037T1321 1110Q1484 1110 1592 1030T1752 808T1793 481H1595V557Q1593 729 1534 827T1320 925Q1216 925 1152 876T1059 739T1029 540Q1029 370 1102 269T1320 167Q1408 167 1477 210T1585 339L1778 274Q1740 177 1671 109T1515 6T1330 -30ZM482 139Q581 139 659 186T771 297Q790 335 799 379T811 465T812 541L879 505L610 487Q568 484 513 477T407 450T321 394T287 297Q287 224 339 182T482 139ZM457 -30Q277 -30 179 59T80 291Q80 379 114 438T205 534T327 591T457 620T573 633L853 655L809 616Q819 722 792 788T708 885T571 917Q484 917 413 878T311 751L119 810Q150 898 214 965T370 1071T576 1110Q748 1110 853 1038T997 838Q1012 786 1015 737T1019 655L918 241Q870 141 799 82T641 -4T457 -30ZM965 481V649H1693V481H965Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1137,
    d: "M563 -482Q524 -482 491 -472T428 -447L476 -319Q519 -333 545 -333Q578 -333 595 -314T613 -271Q613 -230 574 -212T482 -177L554 27L687 29L644 -95Q700 -122 732 -167T765 -277Q765 -367 705 -424T563 -482ZM602 -30Q436 -30 320 44T143 247T80 540Q81 707 144 835T324 1037T605 1110Q782 1110 907 1022T1073 781L865 721Q834 812 764 862T602 913Q499 913 433 865T335 732T302 540Q303 373 378 270T602 167Q703 167 765 213T861 347L1073 297Q1020 139 898 55T602 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1193,
    d: "M533 1240L390 1590H554L697 1240H533ZM619 -30Q458 -30 337 40T148 237T80 531Q80 708 146 838T332 1039T609 1110Q774 1110 890 1034T1063 816T1109 481H900V557Q898 745 829 835T617 925Q460 925 381 826T302 540Q302 362 381 265T609 167Q707 167 778 211T890 339L1095 274Q1032 129 904 50T619 -30ZM234 481V644H1005V481H234Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1193,
    d: "M712 1240H548L691 1590H855L712 1240ZM619 -30Q458 -30 337 40T148 237T80 531Q80 708 146 838T332 1039T609 1110Q774 1110 890 1034T1063 816T1109 481H900V557Q898 745 829 835T617 925Q460 925 381 826T302 540Q302 362 381 265T609 167Q707 167 778 211T890 339L1095 274Q1032 129 904 50T619 -30ZM234 481V644H1005V481H234Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1193,
    d: "M257 1240L516 1540H696L955 1240H755L606 1417L457 1240H257ZM619 -30Q458 -30 337 40T148 237T80 531Q80 708 146 838T332 1039T609 1110Q774 1110 890 1034T1063 816T1109 481H900V557Q898 745 829 835T617 925Q460 925 381 826T302 540Q302 362 381 265T609 167Q707 167 778 211T890 339L1095 274Q1032 129 904 50T619 -30ZM234 481V644H1005V481H234Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1193,
    d: "M710 1261V1461H910V1261H710ZM307 1261V1461H507V1261H307ZM619 -30Q458 -30 337 40T148 237T80 531Q80 708 146 838T332 1039T609 1110Q774 1110 890 1034T1063 816T1109 481H900V557Q898 745 829 835T617 925Q460 925 381 826T302 540Q302 362 381 265T609 167Q707 167 778 211T890 339L1095 274Q1032 129 904 50T619 -30ZM234 481V644H1005V481H234Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 529,
    d: "M179 1240L37 1590H201L343 1240H179ZM160 0V1080H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 529,
    d: "M350 1240H186L329 1590H493L350 1240ZM160 0V1080H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 529,
    d: "M-73 1240L185 1540H365L624 1240H424L275 1417L127 1240H-73ZM160 0V1080H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 529,
    d: "M366 1261V1461H566V1261H366ZM-37 1261V1461H163V1261H-37ZM160 0V1080H369V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1183,
    d: "M593 -30Q438 -31 323 36T145 223T80 503Q81 663 145 783T324 970T593 1037Q676 1037 751 1011T901 927Q886 1037 819 1126T649 1272T421 1337L453 1502Q613 1496 736 1432T939 1251Q1000 1167 1036 1066T1087 829T1103 509Q1103 344 1041 223T864 35T593 -30ZM593 158Q737 158 814 250T892 505Q892 666 813 758T593 849Q447 850 369 759T291 504Q291 340 369 249T593 158ZM629 1091L508 1197L821 1565L941 1460L629 1091Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1230,
    d: "M777 1244Q732 1244 690 1264T608 1309T535 1355T471 1375Q437 1375 426 1343T427 1267H291Q264 1378 306 1454T455 1531Q501 1531 543 1511T624 1466T697 1420T761 1400Q794 1400 806 1431T806 1509H942Q969 1400 927 1322T777 1244ZM898 0V531Q898 594 888 660T848 784T765 876T625 911Q569 911 519 893T432 833T373 725T351 562L221 611Q221 758 276 870T434 1046T683 1109Q795 1109 871 1073T994 979T1067 851T1101 716T1110 600V0H898ZM139 0V1080H326V768H351V0H139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1219,
    d: "M516 1240L374 1590H538L680 1240H516ZM609 -30Q447 -30 328 43T145 244T80 541Q80 710 146 838T331 1038T609 1110Q771 1110 890 1037T1074 836T1139 541Q1139 372 1074 244T889 43T609 -30ZM609 167Q764 167 840 271T917 541Q917 710 840 811T609 913Q504 913 436 866T335 735T302 541Q302 371 380 269T609 167Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1219,
    d: "M692 1240H528L671 1590H835L692 1240ZM609 -30Q447 -30 328 43T145 244T80 541Q80 710 146 838T331 1038T609 1110Q771 1110 890 1037T1074 836T1139 541Q1139 372 1074 244T889 43T609 -30ZM609 167Q764 167 840 271T917 541Q917 710 840 811T609 913Q504 913 436 866T335 735T302 541Q302 371 380 269T609 167Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1219,
    d: "M259 1240L517 1540H697L956 1240H756L607 1417L459 1240H259ZM609 -30Q447 -30 328 43T145 244T80 541Q80 710 146 838T331 1038T609 1110Q771 1110 890 1037T1074 836T1139 541Q1139 372 1074 244T889 43T609 -30ZM609 167Q764 167 840 271T917 541Q917 710 840 811T609 913Q504 913 436 866T335 735T302 541Q302 371 380 269T609 167Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1219,
    d: "M771 1244Q726 1244 684 1264T602 1309T529 1355T465 1375Q431 1375 420 1343T421 1267H285Q258 1378 300 1454T449 1531Q495 1531 537 1511T618 1466T691 1420T755 1400Q788 1400 800 1431T800 1509H936Q963 1400 921 1322T771 1244ZM609 -30Q447 -30 328 43T145 244T80 541Q80 710 146 838T331 1038T609 1110Q771 1110 890 1037T1074 836T1139 541Q1139 372 1074 244T889 43T609 -30ZM609 167Q764 167 840 271T917 541Q917 710 840 811T609 913Q504 913 436 866T335 735T302 541Q302 371 380 269T609 167Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1219,
    d: "M711 1261V1461H911V1261H711ZM309 1261V1461H509V1261H309ZM609 -30Q447 -30 328 43T145 244T80 541Q80 710 146 838T331 1038T609 1110Q771 1110 890 1037T1074 836T1139 541Q1139 372 1074 244T889 43T609 -30ZM609 167Q764 167 840 271T917 541Q917 711 840 812T609 913Q504 913 436 866T335 735T302 541Q302 371 380 269T609 167Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    horizAdvX: 1080,
    d: "M120 637V805H960V637H120ZM496 902V1123H717V902H496ZM496 418V639H717V418H496Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1219,
    d: "M188 -20L48 120L224 296L286 330L853 895L875 945L1031 1100L1171 959L1001 792L950 767L395 212L354 146L188 -20ZM609 -30Q447 -30 328 43T145 244T80 541Q80 710 146 838T331 1038T609 1110Q771 1110 890 1037T1074 836T1139 541Q1139 372 1074 244T889 43T609 -30ZM609 167Q764 167 840 271T917 541Q917 710 840 811T609 913Q504 913 436 866T335 735T302 541Q302 371 380 269T609 167Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1230,
    d: "M530 1240L388 1590H552L694 1240H530ZM547 -29Q435 -29 359 7T236 101T163 229T129 364T120 480V1080H332V549Q332 486 342 420T382 296T465 204T605 169Q661 169 711 187T798 247T857 355T879 518L1009 469Q1009 322 954 210T796 34T547 -29ZM904 0V312H879V1080H1090V0H904Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1230,
    d: "M678 1240H514L657 1590H821L678 1240ZM547 -29Q435 -29 359 7T236 101T163 229T129 364T120 480V1080H332V549Q332 486 342 420T382 296T465 204T605 169Q661 169 711 187T798 247T857 355T879 518L1009 469Q1009 322 954 210T796 34T547 -29ZM904 0V312H879V1080H1090V0H904Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1230,
    d: "M253 1240L512 1540H692L951 1240H751L602 1417L453 1240H253ZM547 -29Q435 -29 359 7T236 101T163 229T129 364T120 480V1080H332V549Q332 486 342 420T382 296T465 204T605 169Q661 169 711 187T798 247T857 355T879 518L1009 469Q1009 322 954 210T796 34T547 -29ZM904 0V312H879V1080H1090V0H904Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1230,
    d: "M706 1261V1461H906V1261H706ZM303 1261V1461H503V1261H303ZM547 -29Q435 -29 359 7T236 101T163 229T129 364T120 480V1080H332V549Q332 486 342 420T382 296T465 204T605 169Q661 169 711 187T798 247T857 355T879 518L1009 469Q1009 322 954 210T796 34T547 -29ZM904 0V312H879V1080H1090V0H904Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1097,
    d: "M639 1240H475L618 1590H782L639 1240ZM286 -480L495 89L498 -79L27 1080H245L597 185H533L869 1080H1081L485 -480H286Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1216,
    d: "M140 837V1440H351V837H140ZM647 -30Q492 -30 387 45T228 250T174 541Q174 703 227 832T385 1035T643 1110Q795 1110 905 1036T1076 833T1136 541Q1136 379 1077 250T908 45T647 -30ZM139 -480V1080H325V303H349V-480H139ZM618 159Q718 159 783 210T881 347T914 541Q914 647 882 733T782 870T611 921Q513 921 450 873T356 739T325 541Q325 429 355 343T450 208T618 159Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1097,
    d: "M662 1261V1461H862V1261H662ZM259 1261V1461H459V1261H259ZM286 -480L495 89L498 -79L27 1080H245L597 185H533L869 1080H1081L485 -480H286Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1080,
    d: "M120 547V715H960V547H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 1560,
    d: "M120 547V715H1440V547H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 527,
    d: "M367 959Q259 941 202 1001T145 1179V1440H367V1199H251Q247 1156 254 1122T286 1069T354 1053L367 959Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 527,
    d: "M160 960L173 1053Q216 1050 240 1069T272 1122T275 1199H160V1440H381V1179Q381 1061 325 1001T160 960Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 581,
    d: "M120 -239L133 -146Q176 -149 200 -130T232 -77T235 0H120V241H341V-20Q341 -138 285 -198T120 -239Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 849,
    d: "M689 1445L677 1352Q633 1355 609 1336T577 1283T574 1206H689V965H468V1226Q468 1344 524 1404T689 1445ZM381 1445L369 1352Q325 1355 301 1336T269 1283T266 1206H381V965H160V1226Q160 1344 216 1404T381 1445Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 849,
    d: "M160 966L173 1059Q216 1056 240 1075T272 1128T275 1205H160V1446H381V1185Q381 1067 325 1007T160 966ZM468 966L481 1059Q524 1056 548 1075T580 1128T583 1205H468V1446H689V1185Q689 1067 633 1007T468 966Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 849,
    d: "M160 -239L173 -146Q216 -149 240 -130T272 -77T275 0H160V241H381V-20Q381 -138 325 -198T160 -239ZM468 -239L481 -146Q524 -149 548 -130T580 -77T583 0H468V241H689V-20Q689 -138 633 -198T468 -239Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 1373,
    d: "M692 363Q616 363 555 398T457 493T420 630Q420 706 456 766T554 862T692 897Q763 897 822 862T917 767T953 630Q953 554 918 494T823 398T692 363Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 1259,
    d: "M757 153L280 630L757 1107L887 977L533 630L887 283L757 153Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 1259,
    d: "M503 153L372 283L727 630L372 977L503 1107L979 630L503 153Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManropeV13Latin600);
export default __webpack_public_path__ + "static/media/manrope-v13-latin-600.1aeaaf5f0b1f096a55fdaceac9316de6.svg";
export { ForwardRef as ReactComponent };